import axios from 'axios';
import { Base_URL } from "../url";

export const fetchCustomerLocation = async (customerCode) => {
  console.log(customerCode, 'customerCode')
  const url = `${Base_URL}/CustomerLocation/GetLocationIdByCustomerCode?customerCode=${customerCode}`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    // return
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const fetchRequestedServices = async () => {
  const url = `${Base_URL}/CustomerRequests/CustomerRequestGetAllData`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    // return
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
};

export const saveServiceRequest = async (formValues, userName) => {
  try {
    console.log(formValues, 'formValues')
    // console.log(userName, 'userName')
    formValues.itemData = formValues.itemData.map((item) => {
      const [datePart, timePart] = item.dateTime.split("T");

      return {
        ...item,
        PreferrredDate: datePart,              // e.g., "2025-08-20"
        PreferrredTime: timePart              // e.g., "17:37"
      };
    });

    console.log(formValues, 'formValues updated')
    // return
    const response = await axios.post(
      `${Base_URL}/CustomerRequests/CustomerRequestUpload?userName=${userName}`,  // https://localhost:7039/api/CustomerRequests/CustomerRequestUpload?userName=5
      formValues);
    return response.data;
  } catch (error) {
    console.log(error.response?.data, 'error.response?.data')
    throw error.response?.data || "Failed to Assigned";
  }
};



export const getServiceRequestDataById = async (requestId) => {
  const url = `${Base_URL}/CustomerRequests/CustomerRequestGetAllDataWithRequestId?customerRequestId=${requestId}`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    // return
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 


export const fetchItemMasterValue = async (itemId) => {
  // const url = `${Base_URL}/CustomerRequests/CustomerRequestGetAllDataWithRequestId?customerRequestId=${itemId}`;
  try {
    // const response = await axios.get(url);
    // console.log(response.data, 'response on body type')
    // return
    return "300";
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}


export const sendPropsedDateAPI = async (propDate, requestId, userName) => {
  console.log(requestId, 'requestId')
  console.log(propDate, 'propDate')
  let proposedDate = {
    proposedDate: propDate
  }
  try {
    const response = await axios.patch(`${Base_URL}/CustomerRequests/UpdateProposedDate/${requestId}?userName=${userName}`, proposedDate);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 


export const sendMailForCustomer = async (requestId, userName) => {
  console.log(requestId, 'requestId')
  
  try {
    const response = await axios.post(`${Base_URL}/CustomerRequests/SendRequestDetailsEmail/${requestId}`);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  

export const allocateItems = async (data, userName) => {
  console.log(data, 'data')

  console.log(userName, 'userName')

  // return


  const [datePart, timePart] = data.proposedDate.split("T");

  data = {
    ...data,
    proposedDate: datePart,              // e.g., "2025-08-20"
    proposedTime: timePart
  }


  const { requestItemId } = data;
  try {
    const response = await axios.patch(`${Base_URL}/CustomerRequests/UpdateAllocatedQuantity/${requestItemId}?userName=${userName}`, data);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 

export const sendMailToCustomer = async (customerRequestId) => {
  console.log(customerRequestId, 'requestItemId')
  // return
  try {
    const response = await axios.post(`${Base_URL}/CustomerRequests/SendProposedDateEmail/${customerRequestId}`);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 


export const sendCustomerConf = async (requestId, userName) => {
  console.log(requestId, 'requestId')
  // 'https://localhost:7039/api/CustomerRequests/UpdateServiceStatus/21?userName=5' \
  try {
    const response = await axios.patch(`${Base_URL}/CustomerRequests/UpdateServiceStatus/${requestId}?userName=${userName}`);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  

export const uploadCompImages = async (formdata, requestid, user) => {
  console.log(formdata, 'formdata')
  console.log(requestid, 'requestid')
  console.log(user, 'user')

  // return
  try {
    const response = await axios.post(`${Base_URL}/CustomerRequests/customerrequest-update-files?requestId=${requestid}&userName=${user}`, formdata);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 


export const getServiceRequestByCustomer = async (requestId) => {
  const url = `${Base_URL}/CustomerRequests/CustomerRequestItemGetData?userName=${requestId}`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    // return
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 


export const sendCustomerAccept = async (requestId, userName) => {
  console.log(requestId, 'requestId')
  // 'https://localhost:7039/api/CustomerRequests/UpdateServiceStatus/21?userName=5' \
  try {
    const response = await axios.patch(`${Base_URL}/CustomerRequests/UpdateServiceAcceptance/${requestId}?userName=${userName}`);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  

export const getServiceRequestForCustomer = async () => {
  const url = `${Base_URL}/CustomerRequests/CustomerRequestItemForAdmin`;
  try {
    const response = await axios.get(url);
    console.log(response.data, 'response on body type')
    // return
    return response.data;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  // 

export const sendAdminClosed = async (requestId, userName) => {
  console.log(requestId, 'requestId')
  try {
    const response = await axios.patch(`${Base_URL}/CustomerRequests/UpdateServiceClosed/${requestId}?userName=${userName}`);
    console.log(response, 'response on body type')
    // return
    return response;
  } catch (error) {
    console.error('Error fetching user data:', error);
    throw error;
  }
}  
